import { PolicyType } from 'store/modules/Policies/types';

const filterPolicies = (policies: Array<PolicyType>) =>
  policies
    .filter(
      (policy: PolicyType) => policy.advisor_charges_definitions.length > 0
    )
    .map((policy: PolicyType) => {
      const { advisor_charges_definitions } = policy;

      return advisor_charges_definitions[0];
    });

export const sumChargesAmmount = (policies: Array<PolicyType>) => {
  const charges = filterPolicies(policies);

  const sumCharges = charges.reduce(
    (a: any, b: any) => {
      return { amount: Number(a.amount) + Number(b.amount) };
    },
    { amount: 0 }
  );
  return sumCharges.amount;
};

export const averageChargesPercentage = (policies: Array<PolicyType>) => {
  const charges = filterPolicies(policies);

  const averageCharge = charges.reduce(
    (a: any, b: any) => {
      return {
        percentage_value:
          Number(a.percentage_value) + Number(b.percentage_value)
      };
    },
    { percentage_value: 0 }
  );
  if (averageCharge.percentage_value === 0) return 0;

  return (averageCharge.percentage_value * 100) / charges.length;
};

export const sumAppliedCharge = (policies: Array<PolicyType>) => {
  return [...policies].reduce(
    (policyA: any, policyB: any) => {
      const amountA = Number(policyA.appliedAdvisorCharge.amount || 0);
      const amountB = Number(policyB.appliedAdvisorCharge.amount || 0);

      const chargeApercent = policyA.appliedAdvisorCharge.percentage_value
        ? Number(policyA.appliedAdvisorCharge.percentage_value)
        : 0;
      const chargeBpercent = policyB.appliedAdvisorCharge.percentage_value
        ? Number(policyB.appliedAdvisorCharge.percentage_value)
        : 0;
      return {
        appliedAdvisorCharge: {
          amount: amountA + amountB,
          percentage_value: chargeApercent + chargeBpercent
        }
      };
    },

    { appliedAdvisorCharge: { amount: 0, percentage_value: 0 } }
  );
};

export const sumTotalOngoing = (policies: Array<any>) => {
  const filterNull = policies.filter(
    (policy: any) => policy.total_ongoing_charge_for_summary
  );
  const isAnyValueExist = filterNull.length > 0;
  if (!isAnyValueExist) return null;

  const result = filterNull.reduce(
    (policyA: any, policyB: any) => {
      return {
        total_ongoing_charge_for_summary:
          Number(policyA.total_ongoing_charge_for_summary) +
          Number(policyB.total_ongoing_charge_for_summary)
      };
    },
    {
      total_ongoing_charge_for_summary: 0
    }
  );

  return result.total_ongoing_charge_for_summary;
};
